import { Dic, Dates } from "$utils";
const unFinish = function (that) {
  return {
    maxHeight: "100%",
    page: true,
    editBtn: false,
    delBtn: false,
    header: false,
    menu: true,
    stripe: true,
    emptyText: that.$t("taskCenter.label.noData"),
    menuAlign: "center",
    menuWidth: 150,
    index: true,
    indexLabel: that.$t("taskCenter.label.no"), //this.$t('taskCenter.label.count'),'序号1',
    column: [
      {
        label: "工单名称",
        prop: "taskName",
        search: true,
        //menuWidth: 490,
        columnWidth: 200,
        formatter: function (row, value) {
          return '<a href="javascript:;">' + value + "</a>";
        }
      },
      {
        label: that.$t("taskCenter.label.priority"),
        prop: "taskPriority",
        sortable: true,
        align: "center",
        width: 120,
        formatter: function (row, value) {
          let rtn = "";
          that.prioritys.map((item) => {
            if (item.value == value) {
              rtn = item.label;
            }
          });
          return rtn;
        }
      },
      // {
      //   label: that.$t('taskCenter.label.taskType'),
      //   prop: 'taskType',
      //   align: 'center',
      //   width: 180,
      //   formatter: function (row, value) {
      //     let rtn = ''
      //     that.taskTypes.map(item => {
      //       if (item.value == value) {
      //         rtn = item.label
      //       }
      //     })
      //     return rtn
      //   }
      // },
      {
        label: that.$t("taskCenter.label.creator"),
        prop: "creatorName",
        overHidden: true,
        align: "center",
        width: 180,
        formatter: function (row, value) {
          return '<a href="javascript:;">' + value + "</a>";
        }
      },

      {
        label: that.$t("taskCenter.label.taskVisibilitys"),
        prop: "taskVisibility",
        align: "center",
        width: 180,
        formatter: function (row, value) {
          return Number(value) === 1 ? "仅参与者" : "全员可见";
        }
      },
      // {
      //   label: that.$t('taskCenter.label.taskStartTime'),
      //   prop: 'startTime',
      //   align: 'center',
      //   search: true,
      //   searchSlot: true,
      //   overHidden: true,
      //   sortable: true,
      //   formatter: function (row, value) {
      //     return value ? Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : ''
      //   }
      // },
      {
        label: "任务派发时间",
        prop: "createTime",
        align: "center",
        overHidden: true,
        sortable: true,
        search: true,
        type: "daterange",
        // searchSlot: true,
        formatter: function (row, value) {
          return value ? Dates.dayjs(value).format("YYYY-MM-DD HH:mm:ss") : "";
        }
      },
      {
        label: "工单状态",
        prop: "status",
        width: 100,
        align: "center",
        search: true,
        multiple: true,
        type: "select",
        dicData: Dic.find("SENU012"),
        formatter: function (row, value) {
          let rtn = "";
          that.status.map((item) => {
            if (item.value == value) {
              rtn = item.label;
            }
          });
          return rtn;
        }
      },
      {
        label: "经办人",
        prop: "executorNames",
        overHidden: true,
        align: "center",
        width: 180,
        search: false
      },
      {
        label: "执行人员",
        prop: "executorNames",
        overHidden: true,
        align: "center",
        width: 180,
        search: true,
        hide: true
      }
    ]
  };
};

const finish = function (that) {
  return {
    maxHeight: "100%",
    page: true,
    stripe: true,
    emptyText: that.$t("taskCenter.label.noData"),
    editBtn: false,
    delBtn: false,
    header: false,
    menu: false,
    index: true,
    indexLabel: that.$t("taskCenter.label.no"),
    column: [
      {
        label: that.$t("taskCenter.label.taskNames"),
        prop: "taskName",
        formatter: function (row, value) {
          return '<a href="javascript:;">' + value + "</a>";
        }
      },
      {
        label: that.$t("taskCenter.label.priority"),
        prop: "taskPriority",
        sortable: true,
        width: 100,
        formatter: function (row, value) {
          let rtn = "";
          that.prioritys.map((item) => {
            if (item.value == value) {
              rtn = item.label;
            }
          });
          return rtn;
        }
      },
      {
        label: that.$t("taskCenter.label.taskType"),
        prop: "taskType",
        align: "center",
        width: 180,
        formatter: function (row, value) {
          let rtn = "";
          that.taskTypes.map((item) => {
            if (item.value == value) {
              rtn = item.label;
            }
          });
          return rtn;
        }
      },
      {
        label: that.$t("taskCenter.label.creator"),
        prop: "creatorName",
        overHidden: true,
        align: "center",
        width: 180
      },
      {
        label: that.$t("taskCenter.label.taskStartTime"),
        prop: "startTime",
        align: "center",
        sortable: true,
        formatter: function (row, value) {
          return value ? Dates.dayjs(value).format("YYYY-MM-DD HH:mm:ss") : "";
        }
      },
      {
        label: that.$t("taskCenter.label.taskCreateTime"),
        prop: "createTime",
        align: "center",
        sortable: true,
        formatter: function (row, value) {
          return value ? Dates.dayjs(value).format("YYYY-MM-DD HH:mm:ss") : "";
        }
      },
      {
        label: that.$t("taskCenter.label.modifyTime"),
        prop: "modifyTime",
        formatter: function (row, value) {
          return value ? Dates.dayjs(value).format("YYYY-MM-DD HH:mm:ss") : "";
        }
      }
    ]
  };
};

export { finish, unFinish };
